export enum Language {
  Kyrgyz = 'KG',
  Russian = 'RU',
}
